export default __webpack_public_path__ + "static/media/NLR-8.355fd32a.webp";